import React from 'react';
import { Tr, Td, Checkbox, Text, Flex, Badge, Menu, MenuButton, IconButton, Portal, MenuList, MenuItem } from '@chakra-ui/react';
import { CiMenuKebab } from 'react-icons/ci';
import { FaRegEye } from 'react-icons/fa6';
import { TbListDetails } from 'react-icons/tb';

const GestStockOrderRow = React.memo(({
    val,
    isSelected,
    selectedRowBg,
    handleCheckboxClick,
    saveScrollPosition,
    tableRefCurrent,
    navigate,
    textSM,
    currentBusiness,
    t,
    onOpenAlert,
    onOpenPreview
}) => {
    return (
        <Tr
            bg={isSelected ? selectedRowBg : undefined}
            cursor="pointer"
            _hover={{ bg: "whiteAlpha.100" }}
            onClick={() => {
                saveScrollPosition(tableRefCurrent);
                navigate('/Detail-Gestion-confirmation', {
                    state: {
                        id: val.id,
                        tel: val.tel
                    }
                });
            }}
        >
            <Td position="sticky" left={0} zIndex={1} bg="white" _dark={{ bg: "gray.700" }} onClick={(e) => e.stopPropagation()}>
                <Checkbox
                    size="md"
                    colorScheme='purple'
                    isChecked={isSelected}
                    onChange={() => handleCheckboxClick(val.id)}
                />
            </Td>
            <Td>{val.code}</Td>
            <Td>
                <Flex flexDirection={"column"}>
                    <Text fontWeight='semibold'>{val.full_name}</Text>
                    {val.email !== "undefined" && <Text fontSize='sm' color={textSM}>{val.email}</Text>}
                </Flex>
            </Td>
            <Td>
                <Flex flexDirection={"column"}>
                    <Text fontSize={'md'}>{val.pays}, {val.ville}</Text>
                    <Text fontSize={'sm'} color={textSM}>{val.address}</Text>
                </Flex>
            </Td>
            <Td>
                <a href={`https://wa.me/${val.tel}`} target='blank' onClick={(e) => e.stopPropagation()}>
                    {val.tel}
                </a>
            </Td>
            <Td>
                <Badge colorScheme={
                    val?.status_stock !== 'Collecté'
                        ? (['Épuisé', 'Annulé'].includes(val?.status_stock))
                            ? 'red'
                            : ([null, ''].includes(val?.status_stock))
                                ? 'blue'
                                : 'orange'
                        : 'green'
                } rounded="xl" px={2} cursor='pointer' textTransform='uppercase' onClick={(e) => {
                    e.stopPropagation();
                    if ((val.status_delivery === '') || (val.status_delivery === null)) {
                        onOpenAlert(val.id);
                    }
                }}>
                    {val?.status_stock ? val?.status_stock : 'Nouveau'}
                </Badge>
            </Td>
            <Td>
                <Text textAlign='center'>
                    {val.coupon ? val.couponTitle : '-'}
                </Text>
            </Td>
            <Td>
                <Flex gap={1} alignItems="center">
                    <Text color={val?.coupon && 'gray.400'} fontSize={val?.coupon && 15} fontWeight='semibold' textDecoration={val?.coupon && 'line-through'}>{val?.price}</Text>
                    <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                </Flex>
                {
                    val?.coupon &&
                    <Flex gap={1} alignItems="center">
                        <Text fontWeight='semibold'>{val?.priceWithCoupon}</Text>
                        <Text h={"100%"} fontSize={12} >{currentBusiness?.order_currency}</Text>
                    </Flex>
                }
            </Td>
            <Td>
                <Flex flexDirection="column">
                    <Text fontSize="sm" fontWeight="medium">{new Date(val.date_creation).toLocaleDateString()}</Text>
                    <Text fontSize="xs" color="gray.500">{new Date(val.date_creation).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Text>
                </Flex>
            </Td>
            <Td>
                {val.date_modification ? (
                    <Flex flexDirection="column">
                        <Text fontSize="sm" fontWeight="medium">{new Date(val.date_modification).toLocaleDateString()}</Text>
                        <Text fontSize="xs" color="gray.500">{new Date(val.date_modification).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</Text>
                    </Flex>
                ) : (
                    <Text fontSize="sm" color="gray.400">-</Text>
                )}
            </Td>
            <Td position="sticky" right={0} zIndex={1} bg="white" _dark={{ bg: "gray.700" }} onClick={(e) => e.stopPropagation()}>
                <Menu>
                    <MenuButton
                        as={IconButton}
                        aria-label='Options'
                        icon={<CiMenuKebab />}
                        variant='outline'
                    />
                    <Portal>
                        <MenuList zIndex={9999}>
                            <MenuItem icon={<TbListDetails size={18} />} onClick={() => {
                                saveScrollPosition(tableRefCurrent);
                                navigate('/Detail-Gestion-confirmation', {
                                    state: {
                                        id: val.id,
                                        tel: val.tel
                                    }
                                });
                            }}>
                                {t("Détails")}
                            </MenuItem>
                            <MenuItem icon={<FaRegEye size={18} />} onClick={() => onOpenPreview(val.id)}>
                                {t("Aperçu")}
                            </MenuItem>
                        </MenuList>
                    </Portal>
                </Menu>
            </Td>
        </Tr>
    )
}, (prevProps, nextProps) => {
    return prevProps.val === nextProps.val && prevProps.isSelected === nextProps.isSelected;
});

export default GestStockOrderRow;
